// Mood -> experience ID mapping for the homepage ExperienceSelector.
// These IDs match active rows in the D1 `experiences` table (IDs 5-28).
// If experiences are added/removed in the future, update this map accordingly.

export const MOOD_EXPERIENCE_MAP: Record<string, number[]> = {
  '二人世界': [27, 22, 24, 25],
  '親子同樂': [10, 15, 17, 19],
  '朋友同遊': [8, 16, 17, 20, 26],
  '探險派': [5, 7, 9, 11, 28],
  '靜心放空': [13, 14, 20, 26],
};

export const MOOD_LABELS = Object.keys(MOOD_EXPERIENCE_MAP);
